export const sendingFrequency = {
  monthly: 'Ежемесячная отправка',
  weekly: 'Еженедельная отправка',
  daily: 'Еженедневная отправка',
};

export const sendingFrequencyList = [
  { text: 'Ежемесячная отправка', value: 'monthly' },
  { text: 'Еженедельная отправка', value: 'weekly' },
  { text: 'Еженедневная отправка', value: 'daily' },
];

export const pushType = {
  periodical: ' Периодичная',
  one_time: 'Разовое',
};

export const segmentType = {
  general: 'По параметрам',
  by_clients: 'По клиентам',
};

export const taxStatuses = [
  {
    text: 'На оплате (у клиента)',
    value: 'on_payment',
  },
  {
    text: 'Оплачен',
    value: 'paid',
  },
  {
    text: 'Отправлен в КГД',
    value: 'paid_kgd',
  },
  {
    text: 'Отправлен в ПДГ',
    value: 'paid_gfc',
  },
];

export const taxStatusesMap = {
  on_payment: 'На оплате (у клиента)',
  paid: 'Оплачен',
  paid_kgd: 'Отправлен в КГД',
  paid_gfc: 'Отправлен в ПДГ',
};

export const dateType = {
  static: 'Статичная',
  dynamic: 'Динамичная',
};

export const dayType = {
  start: 'Начало',
  end: 'Окончания',
};
